import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import api from "../../api";

// Settings → Patient alerts (backend notifications/patient_notify.py): for each
// moment the clinic tells a patient something, choose the channels.
const CHANNEL_LABEL = { in_app: "In the app", sms: "SMS", whatsapp: "WhatsApp", email: "Email" };

export default function PatientAlertsCard() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(null);
  let isOrgAdmin = false;
  try { isOrgAdmin = (jwtDecode(JSON.parse(localStorage.getItem("auth") || "{}").token)?.sub?.role || "").toLowerCase() === "admin"; } catch { isOrgAdmin = false; }

  useEffect(() => { api.getPatientAlerts().then((r) => setData(r.data)).catch(() => setData(false)); }, []);

  if (data === null) return <p className="text-sm text-gray-500">Loading…</p>;
  if (data === false) return <p className="text-sm text-gray-500">Only admins can see patient alert settings.</p>;

  const toggle = async (event, channel) => {
    const next = !data.settings[event][channel];
    setSaving(`${event}.${channel}`);
    try {
      const r = await api.updatePatientAlerts({ [event]: { [channel]: next } });
      setData(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.error || "Couldn't save.");
    } finally {
      setSaving(null);
    }
  };

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="w-full text-sm min-w-[420px]">
          <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
            <tr>
              <th className="text-left px-4 py-2.5">When</th>
              {data.channels.map((c) => (
                <th key={c} className="px-3 py-2.5 text-center">{CHANNEL_LABEL[c] || c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.events.map((e) => (
              <tr key={e.key} className="border-t border-gray-100">
                <td className="px-4 py-3">
                  <p className="font-semibold text-gray-800">{e.label}</p>
                  <p className="text-xs text-gray-500">{e.description}</p>
                </td>
                {data.channels.map((c) => (
                  <td key={c} className="px-3 py-3 text-center">
                    <input type="checkbox" className="h-4 w-4" aria-label={`${e.label} by ${CHANNEL_LABEL[c]}`}
                      checked={data.settings[e.key][c]} disabled={!isOrgAdmin || saving === `${e.key}.${c}`}
                      onChange={() => toggle(e.key, c)} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-gray-500">
        {data.channels.length === 1 ? "Patients get these alerts in the app. SMS, WhatsApp and email appear here once MindConnect turns them on for your clinic." : "Only the channels set up for your clinic are shown."}
        {!isOrgAdmin && " Only the organisation's admin can change these."}
      </p>
    </div>
  );
}
